module.exports = __webpack_public_path__ + "static/img/BF.e3679437.svg";